import { sendContactApi } from '@/ui/services/contact/send-contact'
import { useMutation } from '@tanstack/react-query'

export function useSendContact() {
  return useMutation({
    mutationFn: sendContactApi,
  })
}
